import React, { FC, ReactElement, Fragment } from 'react';
import classNames from 'classnames/bind';
import PostCard from 'sections/Blog/components/SectionPosts/PostCard';
import Social from 'sections/Blog/components/SectionPosts/Social';
import Pagination from 'ui/Pagination';
import styles from 'sections/Blog/components/SectionPosts/SectionPosts.module.scss';

const cn = classNames.bind(styles);

interface SectionPostsProps {
  currentPosts: any;
  setCurrentPage: any;
  pagesQuantity: any;
};

const SectionPosts: FC<SectionPostsProps> = ({ currentPosts, setCurrentPage, pagesQuantity }): ReactElement => {
  const isPostsListShown = currentPosts.length > 0;

  const postsElements = currentPosts.map((post: any) => {
    return (
      <Fragment key={post.id}>
        {post.type === 'social'
          ?
          <Social key={post.type} />
          :
          <PostCard
            key={post.id}
            post={post}
          />
        }
      </Fragment>
    );
  });

  return (
    <section className={cn('posts')}>
      <div className={cn('container')}>
        {isPostsListShown && (
          <>
            <ul className={cn('posts__list')}>
              {postsElements}
            </ul>

            <div className={cn('posts__pagination-container')}>
              <Pagination
                buttonsQuantity={pagesQuantity}
                setCurrentPage={setCurrentPage}
              />
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default SectionPosts;